(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/package-rows.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/package-rows.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.package_rows = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h2 class=\"package-rows-header f-600\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"packageTitle") || (depth0 != null ? lookupProperty(depth0,"packageTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"packageTitle","hash":{},"data":data,"loc":{"start":{"line":1,"column":38},"end":{"line":1,"column":54}}}) : helper)))
    + "</h2>\n<div class=\"package-rows-balls js-package-rows-balls\"></div>\n";
},"useData":true});
Handlebars.partials['components-numbergames-game-package_rows'] = svs.numbergames.game.templates.package_rows;
})(svs, Handlebars);


 })(window);